export const textStyles = {
  uppercase: {
    fontSize: '12px',
    fontWeight: 'medium',
    lineHeight: '1',
    letterSpacing: '0.025rem',
    textTransform: 'uppercase',
  },
}
